import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  invalidateFlashbookDesigns,
  updateFlashbookDesign,
} from '../../services/flashbooks';
import {
  FlashDesignWithRelations,
  UpdateFlashDesignPayload,
} from '../../types/flashbooks';

interface Options {
  onSuccess?: (result: FlashDesignWithRelations) => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
}

function useUpdateFlashbookDesign({ onSuccess, onError }: Options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      flashbookId,
      flashDesignId,
      payload,
    }: {
      flashbookId: string;
      flashDesignId: number;
      payload: UpdateFlashDesignPayload;
    }) =>
      updateFlashbookDesign({
        flashbookId,
        flashDesignId,
        payload,
      }),
    onSuccess: async result => {
      await invalidateFlashbookDesigns();
      await queryClient.invalidateQueries({
        queryKey: ['flashbook-design', { flashDesignId: result.id }],
      });
      await onSuccess?.(result);
    },
    onError: async error => {
      await onError?.(error);
    },
  });
}

export default useUpdateFlashbookDesign;
